var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qilianFooter"},[_vm._v("2018-2020 gongsibao.com 版权所有 ICP备案证书号:京ICP证150505号 京ICP备14043829号-2")])}
var staticRenderFns = []

export { render, staticRenderFns }